import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/articles';

export default function Footer() {
  const mainCategories = categories.filter(c => c.slug !== 'all').slice(0, 6);

  return (
    <footer className="bg-secondary-900">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4 no-underline">
              <span className="font-heading text-xl font-bold text-background-50">
                {siteInfo.name}
              </span>
            </Link>
            <p className="text-sm text-secondary-200 leading-relaxed">
              {siteInfo.tagline}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-secondary-200 hover:text-background-50 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/about" className="text-sm text-secondary-200 hover:text-background-50 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {mainCategories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-secondary-200 hover:text-background-50 transition-colors cursor-pointer">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="text-sm text-secondary-200">{siteInfo.email}</li>
              <li className="text-sm text-secondary-200">{siteInfo.address}</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-700/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-300">
            &copy; {new Date().getFullYear()} {siteInfo.name}. 保留所有权利。
          </p>
          <div className="flex items-center gap-4 text-xs text-secondary-300">
            <span>精选高质量内容一站汇聚</span>
            <span className="hidden sm:inline">·</span>
            <span>让阅读更有价值</span>
          </div>
        </div>
      </div>
    </footer>
  );
}